import { Debt } from '../../interfaces';
import { getAllOpenHouseholdDebtsByAccountTypes } from './getAllOpenHouseholdDebtsByAccountTypes';

export const MORTGAGE_ACCOUNT_TYPES = ['CV', 'CY', 'FL', 'FR', 'RM', 'SM', 'VM'];

export const getAllHouseholdMortgages = (borrowerDebts: Debt[] = [], spouseDebts: Debt[] = []): Debt[] =>
  getAllOpenHouseholdDebtsByAccountTypes(borrowerDebts, spouseDebts, MORTGAGE_ACCOUNT_TYPES);
